var core = {
  400: '#e37169',
  600: '#d8352a',
  700: '#990000'
};
export default core;